import ImageWidgetView from './ImageWidgetView.vue';
import ImageWidgetEditor from './ImageWidgetEditor.vue';

export const type = 'image';
export const view = ImageWidgetView;
export const editor = ImageWidgetEditor;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 200,
    width: 300,
    url: 'https://picsum.photos/200/300',
  };
}
